import React, { memo } from 'react';
import { OrderTableProps } from './OrderRowTypes';
import { OrderRow } from './OrderRow';
import { useVirtualList } from '../../../hooks';

export const OrderTable = memo<OrderTableProps>(
  ({
    orders,
    selectedOrderIds,
    isAllSelected,
    onToggleOrder,
    onToggleAll,
    onViewOrder,
    onDeleteOrder,
  }) => {
    const containerHeight = 600;
    const itemHeight = 180;
    const shouldUseVirtualization = orders.length > 50;

    const { visibleRange, totalHeight, onScroll } = useVirtualList({
      itemCount: orders.length,
      itemHeight,
      containerHeight,
      overscan: 5,
    });

    if (shouldUseVirtualization) {
      const visibleOrders = orders.slice(visibleRange.startIndex, visibleRange.endIndex + 1);

      return (
        <div
          className="divide-y divide-gray-100"
          style={{ height: `${containerHeight}px`, overflow: 'auto' }}
          onScroll={onScroll}
        >
          <div style={{ height: `${totalHeight}px`, position: 'relative' }}>
            {visibleOrders.map((order, relativeIndex) => {
              const absoluteIndex = visibleRange.startIndex + relativeIndex;
              return (
                <div
                  key={order.id}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: `${itemHeight}px`,
                    transform: `translateY(${absoluteIndex * itemHeight}px)`,
                  }}
                >
                  <OrderRow
                    order={order}
                    isSelected={selectedOrderIds.includes(order.id)}
                    onToggle={onToggleOrder}
                    onViewOrder={onViewOrder}
                    onDeleteOrder={onDeleteOrder}
                    index={absoluteIndex}
                  />
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="divide-y divide-gray-100">
        {orders.map((order, index) => (
          <OrderRow
            key={order.id}
            order={order}
            isSelected={selectedOrderIds.includes(order.id)}
            onToggle={onToggleOrder}
            onViewOrder={onViewOrder}
            onDeleteOrder={onDeleteOrder}
            index={index}
          />
        ))}
      </div>
    );
  }
);

OrderTable.displayName = 'OrderTable';
